import { lazy } from "react";
import Navbar from "./Navbar";
import SideBar from "./SideBar";
import jwtDecode from "jwt-decode";

const FinancierWiseAuctionList = lazy(() =>
  import("../../components/auction/FinancierWiseAuctionList")
);
const LeadManagement = lazy(() =>
  import("../../features/lead-generation/LeadManagement")
);
const LeadDashboard = lazy(() =>
  import("../../features/lead-generation/dashboard/LeadDashboard")
);

const components = {
  financier_list: FinancierWiseAuctionList,
  lead_management: LeadManagement,
  lead_dashboard: LeadDashboard,
};

function Layout() {
  const refreshToken = localStorage.getItem("refreshToken");
  const user = jwtDecode(refreshToken);
  const local_storage_key = `meratractor_dashboard_${user?.state}_${user?.designation}`;
  const menuList = [
    {
      key: "auction",
      label: "Auction",
      iconClass: "bi bi-hammer",
      children: [
        {
          key: "dashboard",
          label: "Dashboard",
          children: [
            { key: "financier_list", label: "Financier wise list" },
            { key: "summary_data", label: "Summary Data" },
          ],
        },
        {
          key: "taskboard",
          label: "Taskboard",
          children: [
            { key: "payment_pending", label: "Payment Pending" },
            { key: "mmfsl_lots", label: "MMFSL Lots" },
          ],
        },
      ],
    },
    {
      key: "users",
      label: "Users",
      iconClass: "bi bi-people",
      children: [
        { key: "lead_dashboard", label: "Lead Dashboard", iconClass: "bi bi-speedometer2" },
        { key: "lead_management", label: "Lead Management" },
      ],
    },
  ];
  return (
    <>
      {/* <div
        className="d-flex flex-column"
        style={{
          height: "100dvh",
          background:
            "linear-gradient( to right top, #ffffff, #fcfefe, #f9fdfd, #f6fcfc, #f3fbfb, #f0fafa, #edf9f9, #e9f8f7, #e5f7f6, #e1f6f5, #ddf5f4, #d9f4f3, #d5f3f1, #d1f2f0, #cdf1ef, #c9f0ee, #c5efed, #c1eeec, #bdeceb, #b9ebea, #b5eaeb, #b1e9eb, #ade8eb, #aae7eb )",
        }}
      >
        <Navbar />
        <div className=" flex-grow-1">
          <div className="container py-3">
            <div className="card">
              <div className="card-body text-center">
                <h3>Dashboard Demo</h3>
                <p className="mb-3">Check out our new responsive dashboard implementation</p>
                <a href="/demo" className="btn btn-primary">View Dashboard Demo</a>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <SideBar
        components={components}
        menu={menuList}
        local_storage_key={local_storage_key}
      />
    </>
  );
}
export default Layout;
